import { Bootstrap } from 'bootstrap';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'theme';
import { Splash } from 'components/common/splash';
import config from 'config';
import Application from './app';
import { registerPreloadErrorHandler } from './preload-error-handler';
import './base.css';
import 'intl-pluralrules';

registerPreloadErrorHandler();

// Prevents application from running in an iframe
const isInIframe = config.env !== 'test' && !!window.top?.[0];

if (isInIframe && window.top) {
	window.top.location.href = window.location.pathname;
} else {
	const rootElement = document.getElementById('root');
	if (rootElement) {
		const root = createRoot(rootElement);
		root.render(
			<StrictMode>
				<ThemeProvider>
					<BrowserRouter>
						<Bootstrap
							fallback={<Splash message='Loading Application' />}
						>
							<Application />
						</Bootstrap>
					</BrowserRouter>
				</ThemeProvider>
			</StrictMode>
		);
	}
}
